module.exports = __webpack_public_path__ + "static/media/Hoist_ios_4.363d3874.jpg";